var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/integrations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-408.000000, -466.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "integrations",
    transform: "translate(0.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/integrations",
    transform: "translate(33.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 7,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 4
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrations);
export default __webpack_public_path__ + "static/media/icon_integrations.76a8c7b0a8d082c3dc9d351889204db2.svg";
export { ForwardRef as ReactComponent };